import type { FaireProductEntity } from "../../entity_types/product";

export const p_qd8p5u686e: FaireProductEntity = {
  token: "p_qd8p5u686e",
  type: "product",
  name: "Be Peaceful Essential Oil Rollerball, assembled by survivors",
  brandToken: "b_acbb4naqbw",
  brandName: "Crowned Free",
  imageUrl:
    "https://cdn.faire.com/fastly/098c57834d80d502fa86b7f69401a4d6b54fc445abf343827f6658cef3079295.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/170cccd33f35f9f2108564b1b7477caadbd25bf94e64e14a9132076bec78f334.jpeg",
    "https://cdn.faire.com/fastly/6084546e4d1682ae19042b3e716201fbeffa5022197fc2126d8797c7a339b1a0.jpeg",
    "https://cdn.faire.com/fastly/c624da7d164b433bd054f2cb39b9c1952ba28641a5a114e48ae95ff5012c23c9.png",
  ],
  priceDollars: 13.86,
  description:
    " Be Peaceful - Build and Restore\n\n-Made in USA\n-Assembled by survivors and at-risk youth in Michigan\n-Net Wt. 0.34 fl. oz. (10ml)\n\nDirections: Apply directly on your chest, torso, back of neck, shoulders, and bottom of feet.\n\nCaution: For external use only. Keep out of reach of children. Avoid eyes and other sensitive areas. Keep away from direct flame. If pregnant or nursing, consult a physician before using essential oils.\n\nStorage: Store at room temperature and avoid direct sunlight. \n\nOn a mission to end human trafficking through ethical fashion and gifts. At Crowned Free, we are committed to raising awareness, providing safe and sustainable jobs to empower survivors, choosing ethical sourcing for our products, and giving back to anti-trafficking organizations both locally and globally.\n \n\n",
  tags: [],
  msrpDollars: 27.71,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:40.055Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
